'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFoursquare = function FaFoursquare(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.8 9.7l0.8-4.3q0.2-0.6-0.2-0.9t-0.7-0.4h-15.9q-0.5 0-0.9 0.4t-0.3 0.8v24.6q0 0.1 0.1 0l6.5-7.9q0.5-0.5 0.8-0.7t1.1-0.2h5.4q0.4 0 0.8-0.3t0.4-0.7q0.5-2.9 0.8-4.2 0.1-0.5-0.3-0.9t-0.8-0.4h-6.5q-0.7 0-1.1-0.5t-0.4-1v-1q0-0.6 0.4-1t1.1-0.5h7.7q0.4 0 0.8-0.3t0.4-0.6z m5.1-5q-0.3 1.7-1.2 6t-1.6 7.8-0.7 3.9q-0.2 0.5-0.2 0.7t-0.4 0.7-0.5 0.8-0.9 0.4-1.3 0.2h-6q-0.3 0-0.5 0.3-0.2 0.2-9.5 11-0.5 0.6-1.3 0.6t-1.1-0.1q-1.2-0.5-1.2-2.2v-31.4q0-1.3 0.8-2.3t2.7-1.1h19.8q2.1 0 2.9 1.2t0.2 3.5z m0 0l-3.5 17.7q0-0.4 0.7-3.9t1.6-7.8 1.2-6z' })
        )
    );
};

exports.default = FaFoursquare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/foursquare.js
// module id = 834
// module chunks = 168707334958949